import axios from "axios"
import { firebaseauth } from "../../mp-database/firebaseConfig"
import { getEnv } from "../../../utils/env"
import { getCustomHeaders } from "../../mp-utils/generic-utils/Headers"

const apiClient = new axios.Axios({
  baseURL: getEnv("BASE_REPORTING_API"),
  headers: getCustomHeaders()
})

apiClient.interceptors.request.use(async config => {
  const token = await firebaseauth.currentUser.getIdToken(false)

  config.headers["Authorization"] = `Bearer ${token}`

  return config
})

apiClient.interceptors.response.use(response => JSON.parse(response.data))

export default apiClient
